import { lazy } from "react";

const RELOAD_FLAG = "ngw-chunk-reload";

// A tab opened before a deploy still runs the old main.js, which asks for
// chunk filenames the new build no longer has. Reloading once fetches the
// new index.html and its matching chunks. The sessionStorage flag stops a
// reload loop if the chunk is missing for some other reason, in which case
// the error is rethrown to the error boundary / Sentry as before.
const lazyWithReload = (importer) =>
  lazy(async () => {
    try {
      const module = await importer();
      try {
        sessionStorage.removeItem(RELOAD_FLAG);
      } catch {}
      return module;
    } catch (error) {
      let alreadyReloaded = true;
      try {
        alreadyReloaded = sessionStorage.getItem(RELOAD_FLAG) === "1";
        if (!alreadyReloaded) sessionStorage.setItem(RELOAD_FLAG, "1");
      } catch {}
      if (!alreadyReloaded) {
        window.location.reload();
        // Keep Suspense on its fallback while the page reloads.
        return new Promise(() => {});
      }
      throw error;
    }
  });

export default lazyWithReload;
